// TODO

export default class ComponentMap {
  constructor() {

  }

  static fromObject(obj) {
    return new ComponentMap(obj);
  }

  toObject(): Object {

  }
}
